import {
  ChartSettingsSectionRoutes,
  getChartSettingsTestPrefix
} from "@/providers/NavigationProvider";

export const IMPORT_FILTERS_TEST_PREFIX = getChartSettingsTestPrefix(
  ChartSettingsSectionRoutes.ImportFilters
);
